{
  "dashboard": "Dashibodi ya Mfanyabiashara",
  "portfolio": "Kwingineko",
  "transactions": "Miamala",
  "dashboard_page": {
    "title": "Dashibodi ya Mmiliki wa Mikopo",
    "subtitle": "Simamia kwingineko lako la mikopo ya kaboni na fuatilia fursa za soko",
    "stats": {
      "total_credits_owned": "Jumla ya Mikopo Inayomilikiwa",
      "credits_retired": "Mikopo Iliyostaafishwa",
      "portfolio_value": "Thamani ya Kwingineko",
      "active_transactions": "Miamala Inayoendelea",
      "this_month": "mwezi huu",
      "pending": "inasubiri"
    },
    "recent_transactions": {
      "title": "Miamala ya Hivi Karibuni",
      "view_all": "Tazama Zote",
      "purchased_credits": "Mikopo Iliyonunuliwa",
      "retired_credits": "Mikopo Iliyostaafishwa",
      "transferred_credits": "Mikopo Iliyohamishwa",
      "project": "Mradi",
      "to": "Kwa",
      "retired": "Imestaafishwa"
    },
    "quick_actions": {
      "title": "Vitendo vya Haraka",
      "buy_credits": "Nunua Mikopo",
      "transfer_credits": "Hamisha Mikopo",
      "retire_credits": "Staafisha Mikopo",
      "export_ledger": "Hamisha Leja",
      "market_alert": "Tahadhari ya Soko",
      "market_alert_message": "Mahitaji makubwa ya mikopo ya misitu. Fikiria kuuza kwa bei za sasa za soko."
    },
    "portfolio_breakdown": {
      "title": "Mgawanyo wa Kwingineko",
      "renewable_energy": "Nishati Mbadala",
      "forestry_land_use": "Misitu na Matumizi ya Ardhi",
      "energy_efficiency": "Ufanisi wa Nishati",
      "other": "Nyingine",
      "credits": "mikopo"
    },
    "market_insights": {
      "title": "Ufahamu wa Soko",
      "average_credit_price": "Bei ya Wastani ya Mkopo",
      "trading_volume": "Kiasi cha Biashara",
      "new_projects": "Miradi Mipya",
      "from_last_week": "kutoka wiki iliyopita",
      "credits_traded_this_week": "Mikopo iliyouzwa wiki hii",
      "registered_this_month": "Imesajiliwa mwezi huu"
    }
  },
  "register_page": {
    "breadcrumb": {
      "home": "Nyumbani",
      "registration": "Usajili",
      "credit_holder_trader": "Mmiliki wa Mikopo / Mfanyabiashara"
    },
    "header": {
      "title": "Usajili wa Mmiliki wa Mikopo / Mfanyabiashara",
      "subtitle": "Jisajili kununua, kufanya biashara, na kustaafisha mikopo ya kaboni kwenye Daftari la SOR"
    },
    "personal_info": {
      "title": "Taarifa za Kibinafsi",
      "full_name_org": "Jina Kamili / Jina la Shirika",
      "full_name_placeholder": "Ingiza jina lako kamili au jina la shirika",
      "country": "Nchi",
      "select_country": "Chagua nchi yako",
      "email_address": "Anwani ya Barua Pepe",
      "email_placeholder": "barua.pepe{'@'}yako.com",
      "phone_number": "Nambari ya Simu",
      "phone_placeholder": "+1 (555) 123-4567"
    },
    "intended_use": {
      "title": "Matumizi Yanayokusudiwa",
      "buy_credits": {
        "title": "Nunua Mikopo",
        "description": "Nunua mikopo ya kaboni kwa ajili ya kufuata sheria au fidia ya hiari"
      },
      "trade_credits": {
        "title": "Fanya Biashara ya Mikopo",
        "description": "Shiriki katika biashara ya mikopo ya kaboni na shughuli za soko"
      },
      "retire_credits": {
        "title": "Staafisha Mikopo",
        "description": "Staafisha mikopo kabisa kwa madai ya kimazingira"
      }
    },
    "account_security": {
      "title": "Usalama wa Akaunti",
      "password": "Nenosiri",
      "password_placeholder": "Tengeneza nenosiri imara",
      "password_requirements": "Lazima iwe na angalau herufi 8 na herufi kubwa, ndogo, na nambari",
      "confirm_password": "Thibitisha Nenosiri",
      "confirm_password_placeholder": "Thibitisha nenosiri lako"
    },
    "terms_declarations": {
      "title": "Masharti na Matamko",
      "agree_terms": "Ninakubali",
      "terms_conditions": "Masharti na Vigezo",
      "acknowledge_privacy": "Ninakiri",
      "privacy_policy": "Sera ya Faragha",
      "comply_rules": "Ninakubali kufuata sheria na kanuni za Daftari la SOR",
      "marketing_consent": "Ninakubali kupokea masasisho na mawasiliano ya masoko"
    },
    "form_actions": {
      "create_account": "Fungua Akaunti (Bure)",
      "cancel": "Ghairi"
    },
    "registration_info": {
      "title": "Taarifa za Usajili",
      "free_registration": "Usajili ni bure kwa Wamiliki wa Mikopo na Wafanyabiashara",
      "unique_rin": "Utapokea Nambari ya Kitambulisho cha Daftari (RIN) ya kipekee baada ya kuidhinishwa",
      "email_verification": "Uthibitisho wa barua pepe unahitajika ili kuamilisha akaunti yako",
      "approval_time": "Uidhinishaji wa akaunti kwa kawaida huchukua siku 1-2 za kazi",
      "start_trading": "Unaweza kuanza kufanya biashara mara tu baada ya kuamilisha akaunti"
    }
  },
  "sidebar": {
    "dashboard": "Dashibodi",
    "credit_ledger": "Leja ya Mikopo",
    "transfer_credits": "Hamisha Mikopo",
    "retire_credits": "Staafisha Mikopo",
    "market_explorer": "Mchunguzi wa Soko",
    "portfolio_analytics": "Uchambuzi wa Kwingineko"
  }
}